import * as Tgcc from '../tgccGlobal'
import * as React from 'react'
import Radium, { StyleRoot } from 'radium'
import {CSSProperties} from 'react'
import {connect} from 'react-redux'



class LicProps extends Tgcc.BaseProps {
    license: Tgcc.License;
    onChange?: (license: Tgcc.License) => void;
}

const wrapperStyle: CSSProperties = {
    textAlign: 'center',
    padding: '20px'
};

const logoStyle: CSSProperties = {
    maxHeight: '150px'
};
const backButtonStyle: CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#E27558',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    width: '200px',
    fontSize: '13px',
    lineHeight: '28px',
    height: '28px',
    margin: '20px auto 0',
    padding: '0 15px',
    fontFamily:'Reitam'
};

export class _DesignLicenseHeader extends React.Component<LicProps, any> {
    
    state = {}
    
    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingDesignImageSrc;
    }

    showAllSchools = (event: any) => {
        if(this.props.onChange)
            this.props.onChange(undefined);
    }

    render() {
        var caption = this.props.license.license;
        var logoImg = Tgcc.getLogoPath(this.props.license.image);
        return (
            <div style={wrapperStyle}>
                <img src={logoImg} style={logoStyle}  onError={this.handleImageError} alt={logoImg} />
                <div style={backButtonStyle} onClick={this.showAllSchools}>back to all schools</div>
           </div>
        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    if(state && state.FilterDesignsByLicense && ownState.license)
        return { selected: ownState.license.Id == state.FilterDesignsByLicense };
    return {selected: false};
};
export var DesignLicenseHeader = connect(mapStateToProps)(Radium(_DesignLicenseHeader));

